module.exports = __webpack_public_path__ + "static/media/blueTick.102931cc.svg";